module.exports = __webpack_public_path__ + "static/img/LR.11c5d7e7.png";